import { createPortal } from "react-dom";
import React, { useState } from "react";
import { Img } from "../Img/index";
import { Field } from "formik";

interface Props {
    element: any;
    name: string;
    onChange?: any;
}

const OccasionCard = ({ element, name, onChange }: Props) => {
    const [isModalOpen, setModalOpen] = useState(false);

    const handleCardClick = (e: React.MouseEvent) => {
        setModalOpen(true);
    };

    const handleCloseModal = () => {
        setModalOpen(false);
    };

    return (
        <>
            <div>
                <div className="rounded-lg shadow-lg px-2 py-1 flex flex-col gap-2">
                    <div className="flex justify-between items-center">
                        <div className="flex items-center gap-2 cursor-pointer" onClick={handleCardClick}>
                            {!!element?.BannerUrl ? (
                                <Img
                                    src={element?.BannerUrl}
                                    className={
                                        element?.BannerUrl?.split(".")?.[1] === "svg"
                                            ? "w-5 h-5"
                                            : "h-[30px]"
                                    }
                                />
                            ) : (
                                <div className="text-[4vh] bg-gray-300 rounded-lg">
                                    {element?.icon}
                                </div>
                            )}
                            <span className="text-[2vh]">{element?.TITLE || "Name"}</span>
                        </div>
                        {!!onChange && (
                            <label onClick={(e) => e.stopPropagation()}>
                                <Field
                                    type="checkbox"
                                    name={name}
                                    checked={element.IS_OPTED}
                                    className="p-[2vh] rounded border border-solid"
                                    onChange={onChange}
                                />
                            </label>
                        )}
                    </div>
                </div>
            </div>

           {isModalOpen &&
    createPortal(
        <div style={{zIndex: 1000}} className="fixed inset-0 bg-[black] bg-opacity-80 flex justify-center items-center z-50">
            <div className="relative">
                <button
                    className="absolute top-2 right-2 text-[white] text-xl font-bold bg-gray-700 rounded-full w-8 h-8 flex items-center justify-center"
                    onClick={handleCloseModal}
                >
                    ✕
                </button>
                <Img
                    src={element?.BannerUrl}
                    alt={element?.TITLE}
                    className="max-w-full max-h-[90vh] rounded"
                />
            </div>
        </div>,
        document.getElementById("root")! // 👈 target root or custom modal root
    )
}
        </>
    );
};

export default OccasionCard;

// import { Img } from "../Img/index";
// import { Field } from "formik";

// interface Props {
//     element: any;
//     name: string;
//     onChange?: any;
// }

// const OccasionCard = ({ element, name, onChange }: Props) => {
//     return (
//         <div>
//             <div className="rounded-lg shadow-lg px-2 py-1 flex flex-col gap-2">
//                 <div className="flex justify-between items-center">
//                     <div className="flex items-center gap-2">
//                         {!!element?.BannerUrl ? <Img src={element?.BannerUrl} className={element?.BannerUrl?.split(".")?.[1] === "svg" ? "w-5 h-5" : "h-[30px]"} /> : <div className="text-[4vh] bg-gray-300 rounded-lg">{element?.icon}</div>}
//                         <span className="text-[2vh]">{element?.TITLE || "Name"}</span>
//                     </div>
//                     {!!onChange && <label>
//                         <Field
//                             type="checkbox"
//                             name={name}
//                             checked={element.IS_OPTED}
//                             className="p-[2vh] rounded  border border-solid"
//                             onChange={onChange}
//                         />
//                     </label>}
//                 </div>
//             </div>
//         </div>
//     );
// }

// export default OccasionCard;

//  <div className="bg-[white] rounded-lg shadow-lg px-2 py-1 flex flex-col gap-2">
//             <div className="flex justify-between items-center">
//                 <span className="text-[2vh]">{element?.TITLE || "Name"}</span>
//                 {!!onChange && <label>
//                     <Field
//                         type="checkbox"
//                         name={name}
//                         checked={element.IS_OPTED}
//                         className="p-[2vh] rounded  border border-solid"
//                         onChange={onChange}
//                     />
//                 </label>}
//             </div>
//                 <Img src={element?.BannerUrl} className="max-h-[40vh]" />
//             {/* <div className="rounded-lg shadow-lg px-2 py-1 flex flex-col gap-2">
//                 <div className="flex justify-between items-center">
//                     <div className="flex items-center gap-2">
//                         {!!element?.BannerUrl ? <Img src={element?.BannerUrl} className={element?.BannerUrl?.split(".")?.[1] === "svg" ? "w-5 h-5" : "h-[30px]"} /> : <div className="text-[4vh] bg-gray-300 rounded-lg">{element?.icon}</div>}
//                         <span className="text-[2vh]">{element?.TITLE || "Name"}</span>
//                     </div>
//                     {!!onChange && <label>
//                         <Field
//                             type="checkbox"
//                             name={name}
//                             checked={element.IS_OPTED}
//                             className="p-[2vh] rounded  border border-solid"
//                             onChange={onChange}
//                         />
//                     </label>}
//                 </div>
//             </div> */}
//         </div>